@use "sass:math";
@use "~components/DoctorAvatar/tokens" as DoctorAvatar;

.stack {
  display: inline-flex;
  flex-direction: row-reverse;
}

.avatar {
  border: 2px solid var(--white);

  &:not(:last-child) {
    margin-left: math.div(DoctorAvatar.$x-small-size, -2);
  }
}
